module.exports = __webpack_public_path__ + "f0b82e25258d6348fd7781b1ea8ca7d5.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/audio/scanner_beep.mp3
// module id = 384
// module chunks = 1